import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../modules/utils/handleError';
import i18next from 'i18next';
import { VoucherWaitingListApi } from './VoucherWaitingListApi';
import * as Dict from '../../modules/utils/Dict';
import Notice from '../../modules/utils/Notice';
import { NCALayerSign } from '../../components/NCALayer/NCALayerSign';
import { history } from '../../_helpers/history';
import paths from '../../_helpers/paths';
import { translation } from '../../_helpers/Translate';
import _ from 'lodash';

/**
 * Constants
 */

export const voucherWaitingListModule = 'voucherWaitingList';
const SET_DATA = `${voucherWaitingListModule}/SET_DATA`;
const LOADING = `${voucherWaitingListModule}/LOADING`;
const CLEAR_STATE = `${voucherWaitingListModule}/CLEAR_STATE`;

/**
 * Reducer
 */

const initialState = {
  loading: true,
  data: [],
  pageNumber: 1,
  totalElements: 0
};

export default createReducer(initialState, {
  [SET_DATA]: (state, action) => {
    state.data = action.data;
    state.pageNumber = action.pageNumber;
    state.totalElements =
      action.pageNumber === 1 ? action.totalElements : state.totalElements;
  },
  [LOADING]: (state, action) => {
    state.loading = action.loading;
  },
  [CLEAR_STATE]: () => initialState
});

export const clearState = () => ({ type: CLEAR_STATE });

export const loadAppointments = filter => async dispatch => {
  try {
    const { data } = await VoucherWaitingListApi.getWaitingList(JSON.stringify(filter));
    if (data.result.content) {
      for (let row of data.result.content) {
        row.providerLocation = await Dict.item('60', row.queuedRegion);
      }
      if (data.status === 'SUCCESS') {
        const content = [];
        for (let item of data.result.content) {
          let queuedType = item.queuedType
            ? await Dict.item('gu_queued_type', item.queuedType || '')
            : '';
          let appStatusWeb = item.status
            ? await Dict.item('waiting_list_status', item.status || '')
            : '';
          let priorityQueued = item.priorityQueued
            ? await Dict.item('priority_queued', item.priorityQueued || '')
            : '';
          let priorityCategory = item.priorityCategory
            ? await Dict.item('priority_category', item.priorityCategory || '')
            : '';

          content.push({
            ...item,
            queuedTypeStatus: queuedType,
            appStatusWebStatus: appStatusWeb,
            priorityQueuedStatus: priorityQueued,
            priorityCategory: priorityCategory
          });
        }
        dispatch({
          type: SET_DATA,
          data: content,
          pageNumber: data.result.pageNumber,
          totalElements: data.result.totalElements
        });
      } else {
        Notice.error(i18next.t('voucher_waitingList_errorLoad'));
      }
    }
  } catch (error) {
    handleError(error, i18next.t('voucher_waitingList_errorLoad'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};

export const addListWaiting = (id, modal, voucherId) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    const { data } = await VoucherWaitingListApi.getSignStringForWL({
      voucherId: voucherId,
      serviceProviderId: id,
      status: 'WAITING'
    });
    const signature = await NCALayerSign(data.result.signature);
    if (signature) {
      await VoucherWaitingListApi.addListWaiting({
        voucherId: voucherId,
        serviceProviderId: id,
        signature
      });
      modal.close();
      history.push(paths.voucherAppointments);
    }
  } catch (e) {
    const errorCode = _.get(e, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(translation('must_sing_own_signature'));
    } else {
      handleError(e, translation('voucher_waitingList_error_add_waiting_list'));
    }
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};

export const changeDUO = (id, modal, voucherId) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    const { data } = await VoucherWaitingListApi.getSignStringForWL({
      voucherId: voucherId,
      serviceProviderId: id,
      status: 'WAITING'
    });
    const signature = await NCALayerSign(data.result.signature);
    if (signature) {
      await VoucherWaitingListApi.changeDUO({
        voucherId: voucherId,
        serviceProviderId: id,
        signature
      });
      modal.close();
      history.push(paths.voucherWaitingList);
    }
  } catch (e) {
    const errorCode = _.get(e, 'response.data.errors[0].code');
    if (errorCode === 'error.runtime_user_must_sing_own_signature') {
      Notice.error(translation('must_sing_own_signature'));
    } else {
      handleError(e, translation('voucher_waitingList_error_change_waiting_list'));
    }
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};
